<div class="section">
	{{#if editButtonVisible}}
		<button class="button wide edit-button{{#if isEditing}} hidden{{/if}}" data-i18n="common.edit"></button>
		<button class="button wide green finish-button{{#unless isEditing}} hidden{{/unless}}" data-i18n="common.finish"></button>
	{{/if}}
</div>
<div class="section language-section'">
	<select class="language-select">{{{languageSelectOptions}}}</select>
</div>
